import { render, staticRenderFns } from "./MexSucursalCard.vue?vue&type=template&id=3517aac9"
import script from "./MexSucursalCard.vue?vue&type=script&lang=js"
export * from "./MexSucursalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports